import React from 'react';
import { ModalV2 } from 'components/common/modals';
import { showError, showSuccess } from '@utils';
import { bookingsServices } from '@services';
import { useBookingSmsOperations } from 'hooks/bookings';
import BookingSendSmsForm from './BookingSendSmsForm';

const getPayload = (values) => {
  return {
    message: values?.message,
  };
};

const BookingSendSmsModal = ({ booking, isOpen, onClose }) => {
  const { templates, loading } = useBookingSmsOperations();

  const handleSubmit = async (values) => {
    try {
      const payload = getPayload(values);

      await bookingsServices.sendBookingSms(booking.id, payload);
      showSuccess('An sms was sent successfully ');

      onClose();
    } catch (error) {
      showError(error);
    }
  };

  return (
    <ModalV2
      id="template-sms-modal"
      title="Template SMS"
      isOpen={isOpen}
      isSubmitting={loading}
      onClose={onClose}
      maxWidth="sm"
      size="sm"
    >
      <BookingSendSmsForm
        templates={templates}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isLoading={loading}
        defaultValues={{
          phone_number: booking?.user?.phone_number,
          lang: booking?.lang,
        }}
      />
    </ModalV2>
  );
};

export default BookingSendSmsModal;
